import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SideBar from "../../../Saved Address/Components/Side Bar/SideBar";
import "../style.css";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Link, Typography, CircularProgress } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePayment from "./StripePayment";
import Swal from "sweetalert2";
import {
  useGetPaymentMethodQuery,
  useDeletePaymentMethodMutation,
} from "api/payment.js";
// const stripePromise = loadStripe(
//   "pk_test_51LM4cUJM2IaUPP5I801W30PUCYsiNTWBCiU2tLVNcp5D29Ft5NP9jY07CRwOCOK4dE9ha8RcJgExjILlvW76ftUZ00Yn4GHMBK"
// );

const stripePromise = loadStripe(
  "pk_test_51NshLXD9ZZCk3ncUymzGoH4WfDPJr1hbU8WR6rCq369VYF967uNDgEHoQj7hXohbRenoSqMx0FiegkQGiUwHuKC900CV5ePfwS"
);


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 200,
  bgcolor: "background.paper",
  boxShadow: 24,
};

function Payment() {
  const [open, setOpen] = React.useState(false);
  const { data: PaymentMethods, isLoading } = useGetPaymentMethodQuery();
  console.log("payment", PaymentMethods);
  const [deletePayment, { isLoading: isdeleting }] =
    useDeletePaymentMethodMutation();
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleDelete = (id) => {
    deletePayment({ id }).then((res) => {
      if (res.data.status) {
        Swal.fire("Card Deleted Successfully!", "", "success");
      } else {
        Swal.fire("Something went wrong!", "", "error");
      }
    });
  };
  return isLoading || isdeleting ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <Container sx={{ mt: 5 }} maxWidth="xl">
        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
          maxWidth="xl"
        >
          <Typography
            sx={{
              FontFamily: "Outfit",
              fontSize: { lg: "24px", md: "24px", sm: "18px", xs: "18px" },
              fontWeight: "600",
            }}
          >
            My Payment
          </Typography>
          <Button
            sx={{
              padding: "7px 20px",
              height: "40px",
              backgroundColor: "#2B817B",
              color: "white",
              borderRadius: "6px",
              "&.css-tcs1zk-MuiButtonBase-root-MuiButton-root:hover": {
                backgroundColor: "#2B817B",
              },
            }}
            onClick={() => handleOpen()}
          >
            Add New Card
          </Button>
        </Container>
        <Box
          className="bg_victor"
          maxWidth="xl"
          sx={{
            padding: 2,
            backgroundColor: "#70BDD7",
            width: { lg: "80%", md: "80%", sm: "100%", xs: "100%" },
            height: "170px",
            borderRadius: "4px",
            marginTop: { lg: "10px", md: "20px", sm: "20px", xs: "20px" },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: { lg: "10px", md: "20px", sm: "20px", xs: "20px" },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "Outfit",
                fontSize: { lg: "20px", md: "20px", sm: "16px", xs: "16px" },
                fontWeight: "400",
                color: "white",
              }}
            >
              Eatcoast Wallet
            </Typography>
            <Typography
              sx={{
                fontFamily: "Outfit",
                fontSize: { lg: "32px", md: "32px", sm: "24px", xs: "24px" },
                fontWeight: "600",
                marginTop: 3,
                color: "white",
              }}
            >
              $ 00.00
            </Typography>
            <Typography
              sx={{
                fontFamily: "Outfit",
                fontSize: "16px",
                fontWeight: "400",
                color: "#ffff",
              }}
            >
              Your balance
            </Typography>
          </Box>
        </Box>

        {PaymentMethods?.data?.map((item) => (
          <Box
            maxWidth="xl"
            sx={{
              height: "106px",
              padding: "20px",
              border: "1px solid  #E1E1E6",
              borderRadius: "4px",
              width: { lg: "80%", md: "80%", sm: "100%", xs: "100%" },
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              my: 1,
              // border: "1px solid red"
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img
                  src={
                    "/images/paymentIcons/" +
                    item.cardBrand.toLowerCase() +
                    "-curved-32px.png"
                  }
                />
                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontWeight: "600",
                    fontSize: {
                      lg: "20px",
                      md: "20px",
                      sm: "16px",
                      xs: "16px",
                    },
                    color: "#1A1824",
                    marginLeft: 2,
                  }}
                >
                  **** **** **** {item.last4}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "90%",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontSize: {
                      lg: "18px",
                      sm: "18px",
                      sm: "16px",
                      xs: "16px",
                    },
                    fontWeight: "400",
                    color: "#9EA3AE;",
                    textTransform: "capitalize",
                  }}
                >
                  {/* {item.cardBrand} */}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Outfit",
                    fontSize: {
                      lg: "18px",
                      sm: "18px",
                      sm: "16px",
                      xs: "16px",
                    },
                    fontWeight: "400",
                    color: "#9EA3AE;",
                  }}
                >
                  Exp: {item.expiryMonth}/{item.expiryYear}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ ml: "10px", mt: "30px" }}>
              <Box>
                <Button
                  variant="outlined"
                  sx={{
                    backgroundColor: "red",
                    color: "white",
                  }}
                  onClick={() => handleDelete(item._id)}
                >
                  Delete
                </Button>
              </Box>
            </Box>
          </Box>
        ))}

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box>
              <Box
                sx={{
                  pt: "8px",
                  ml: "8px",
                }}
              >
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box>
                <Elements stripe={stripePromise}>
                  <StripePayment handleClose={handleClose} />
                </Elements>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Container>
    </>
  );
}

export default Payment;
